"use client";

import { constants } from "@/environment/constants";
import { Close, PrivacyTip } from "@mui/icons-material";
import { Box, Button, DialogContent, DialogTitle, IconButton, Stack, SwipeableDrawer, Typography } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import React from "react";

export default function SafeBuy() {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <Button
        onClick={() => setOpen((e) => !e)}
        variant="text"
        size="small"
        sx={{
          alignSelf: "center",
          px: { xs: 1, sm: 1.25 },
          fontSize: { xs: "0.8rem", sm: "0.875rem" },
          color: "#0d47a1",
          textTransform: "none",
          whiteSpace: "nowrap",
          borderRadius: 50,
          minWidth: 'auto',
          "& .MuiSvgIcon-root": { color: "#0d47a1" },
        }}
      >
        <PrivacyTip sx={{ fontSize: { xs: 18, sm: 20 } }} />
      </Button>

      <SwipeableDrawer
        anchor="bottom"
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => {}}
        disableDiscovery
        disableSwipeToOpen
        hysteresis={0}
        swipeAreaWidth={0}
        transitionDuration={{ appear: 200, enter: 200, exit: 150 }}
        PaperProps={{
          sx: (theme) => ({
            mx: "auto",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            minHeight: "80%",
            maxHeight: "90%",
            [theme.breakpoints.up("md")]: {
              width: "700px",
              borderTopLeftRadius: 24,
              borderTopRightRadius: 24,
            },
            [theme.breakpoints.down("md")]: {
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
            },
          }),
        }}
        ModalProps={{
          keepMounted: false,
          sx: {
            "& .MuiBackdrop-root": {
              backgroundColor: "rgba(0,0,0, 0.3)",
              backdropFilter: "blur(4px)",
            },
          },
        }}
      >
        {/* Header Drawer */}
        <DialogTitle component="div" sx={{ p: 0, flexShrink: 0 }}>
          <Stack>
            <Box
              width="45px"
              height="5px"
              sx={{
                borderRadius: 50,
                backgroundColor: "grey.400",
                opacity: 0.4,
                mx: "auto",
                mt: 1,
              }}
            />
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ p: 2 }}>
              <Typography
                variant="h6"
                sx={{
                  display: "flex",
                  color: "#0d47a1",
                  fontWeight: 700,
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <PrivacyTip sx={{ fontSize: 28 }} />
                خرید امن و مطمئن در {constants.siteName}
              </Typography>
              <IconButton onClick={() => setOpen(false)}>
                <Close />
              </IconButton>
            </Stack>
          </Stack>
        </DialogTitle>

        {/* محتوای Drawer با انیمیشن */}
        <DialogContent
          sx={{
            p: 0,
            px: { xs: 1, xsm: 1.5, sm: 2 },
            overflowY: "auto",
            flex: 1,
            pb: 2,
          }}
        >
          <AnimatePresence mode="wait">
            {open && (
              <motion.div
                key="content"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 50 }}
                transition={{ duration: 0.3 }}
              >
                <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
                  در فروشگاه <strong>{constants.siteName}</strong>، امنیت و رضایت شما اولویت ماست. {constants.siteName} دارای{" "}
                  <strong>نماد اعتماد الکترونیکی (اینماد)</strong> است و از <strong>درگاه‌های پرداخت امن و معتبر</strong> استفاده می‌کند.
                  تمامی محصولات قبل از ارسال بررسی می‌شوند و استانداردهای امنیت اطلاعات رعایت می‌شوند.
                </Typography>

                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                  امنیت خرید در {constants.siteName}:
                </Typography>

                <ul style={{ marginTop: 0 }}>
                  <li>
                    پرداخت شما از طریق <strong>درگاه‌های امن</strong> انجام می‌شود.
                  </li>
                  <li>
                    امکان <strong>خرید اقساطی</strong> برای راحتی شما فراهم است.
                  </li>
                  <li>
                    سیاست‌های <strong>مرجوعی کالا با سهولت و سرعت، و مطابق قوانین سایت</strong> اجرا می‌شوند.
                  </li>
                  <li>
                    تیم پشتیبانی {constants.siteName} همیشه <strong>کنار شماست</strong> تا تجربه‌ای بدون دغدغه داشته باشید.
                  </li>
                  <li>
                    هزاران مشتری راضی، تجربه‌ای <strong>امن و مطمئن</strong> با {constants.siteName} داشته‌اند.
                  </li>
                </ul>
              </motion.div>
            )}
          </AnimatePresence>
        </DialogContent>
        <Box sx={{ px: { xs: 1, xsm: 1.5, sm: 2 }, pb: 2, pt: 1, flexShrink: 0 }}>
          <Button
            variant="contained"
            size="large"
            disableElevation
            fullWidth
            color="primary"
            sx={{
              borderRadius: "30px",
              px: 4,
              background: "linear-gradient(135deg, rgba(13,71,161,1) 0%, rgba(26,35,126,1) 100%)",
            }}
            onClick={() => setOpen(false)}
          >
            بستن
          </Button>
        </Box>
      </SwipeableDrawer>
    </>
  );
}
